/**
 * Phase 5B — early food-route performance hints (before React paint).
 */
const FOOD_PATH_RE = /^\/(food|checkout)(\/|$)/;

export function bootstrapFoodPerf(): void {
  if (typeof window === "undefined" || !FOOD_PATH_RE.test(window.location.pathname)) return;

  const head = document.head;
  const preload = (href: string, type: string, media?: string) => {
    if (head.querySelector(`link[rel="preload"][href="${href}"]`)) return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = href;
    link.type = type;
    if (media) link.media = media;
    head.appendChild(link);
  };

  preload("/brand/heroes/food-640.webp", "image/webp", "(max-width: 640px)");
  preload("/brand/heroes/food-1280.webp", "image/webp", "(min-width: 641px)");
  preload("/brand/heroes/food.webp", "image/webp");
}
